export const formatLastRunDate = (dateString: string) => {
  if (!dateString) return "";
  
  const date = new Date(dateString);
  
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  
  const formatted = new Intl.DateTimeFormat("en-US", options).format(date);
  
  // Add period after month abbreviation and replace AM/PM format
  return formatted
    .replace(/^(\w{3})/, "$1.")
    .replace(/AM/i, "a.m.")
    .replace(/PM/i, "p.m.");
};
